import { Component, ContentChild, OnInit, TemplateRef } from '@angular/core';
import {animate, state, style, transition, trigger} from '@angular/animations';
import { TableComponent } from "../table/table.component";
import { resolveDotNotationPath } from "../../../../utils/object.utils";
import { Project } from "../../../project";
import { CartService } from "../../../cart/cart.service";
import { Router } from "@angular/router";

@Component({
  selector: 'app-expandable-table',
  templateUrl: './expandable-table.component.html',
  styleUrl: './expandable-table.component.scss',
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({height: '0px', minHeight: '0'})),
      state('expanded', style({height: '*'})),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class ExpandableTable extends TableComponent implements OnInit {
	@ContentChild(TemplateRef) cardTemplate: TemplateRef<any>;

	public MAX_EXPANDED_ROWS = 6;
	public expandedElement: any | null;
	public resolveDotNotationPath = resolveDotNotationPath;

	constructor(
		private readonly router: Router,
		public readonly projectCartService: CartService
	) {
		super();
	}

	ngOnInit() {
		this.MAX_EXPANDED_ROWS = this.template.settings.maxExpandedRows;
	}

	onRowClick(row: any) {
		this.expandedElement = this.expandedElement === row ? null : row;
	}

	openProject(project: Project) {
		this.router.navigate(['/project', project.id]);
	}
}
